/**
 * Settings constants — single source of truth for the admin Settings page.
 *
 * AVAILABLE_MODELS:   list of LLM model identifiers the admin can select from.
 * FEATURE_FLAG_PAGES: list of pages whose visibility can be toggled for
 *                     non-admin users. Admins always see every page.
 *
 * The `key` of each feature flag is the persisted identifier; the `path`
 * matches the route used by the sidebar so visibility checks stay in sync.
 */

export const AVAILABLE_MODELS = [
  { value: "openai/gpt-realtime-1.5", label: "OpenAI · gpt-realtime-1.5" },
  { value: "openai/gpt-realtime-2", label: "OpenAI · gpt-realtime-2" },
];

export const DEFAULT_MODEL = "openai/gpt-realtime-1.5";

export const FEATURE_FLAG_PAGES = [
  {
    key: "agents",
    path: "/agents",
    label: "Agenți",
    description: "Pagina principală cu lista de agenți.",
    icon: "smart_toy",
  },
  {
    key: "calendar",
    path: "/calendar",
    label: "Calendar",
    description: "Pagina de programări și calendar.",
    icon: "calendar_month",
  },
  {
    key: "analytics",
    path: "/analytics",
    label: "Analytics",
    description: "Statistici despre apeluri și programări.",
    icon: "analytics",
  },
];

export const DEFAULT_FEATURE_FLAGS = FEATURE_FLAG_PAGES.reduce((acc, page) => {
  acc[page.key] = true;
  return acc;
}, {});
